import React from "react";
import InfoPage from "../InfoPage";

const ComingSoonPlaceholder = ({ title }) => {
  const content = (
    <div style={{
      gridColumn: '1 / -1',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '80px 24px',
      textAlign: 'center',
      minHeight: 300,
    }}>
      <h2 style={{
        fontFamily: "'Sailors', serif",
        fontSize: 28,
        color: '#0f084b',
        marginBottom: 16,
      }}>
        {title}
      </h2>
      <p style={{
        fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
        fontSize: 16,
        color: '#777E90',
        maxWidth: 440,
        lineHeight: 1.6,
      }}>
        Coming Soon — We're working on something great. Stay tuned!
      </p>
    </div>
  );

  return <InfoPage below={content} disableStamps customMinHeight={600} showInlineLivePulse />;
};

export default ComingSoonPlaceholder;
